
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import routes from './router/router'
import AMap from 'vue-amap'
import App from './App'
// import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import DateFilter from './framework/filters/DateFilter'
import BasicPager from './mixins/BasicPager'
import BasicModel from './framework/basic/BasicModel'
import FormDirective from '@/framework/directives/FormDirective'
import ImageDirective from '@/framework/directives/ImageDirective'
import ConfirmDirective from '@/framework/directives/ConfirmDirective'
import ConfirmInputDirective from '@/framework/directives/ConfirmInputDirective'

import selectDom from '@/framework/directives/selectDom'
import Vuex from 'vuex'

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/style/index.css' // global css
import * as math from 'mathjs'

Vue.prototype.$math = math

require('@/framework/include/element.js')

Vue.use(Vuex)
// Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(AMap)

Vue.use(VueQuillEditor)

AMap.initAMapApiLoader({
  key: '48fa32b4615b892e79559ab46ef4ca81',
  v: '1.4.4',
  uiVersion: '1.0',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Riding']
})

// 注册一个全局自定义指令 v-focus
Vue.directive('permissions', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el, binding) {
    let permissions = JSON.parse(localStorage.permissions)

    let expression = binding.expression
    let hasPermission = false
    for (let i = 0; i < permissions.length; i++) {
      let permission = permissions[i]
      if (expression === "'" + permission + "'") {
        hasPermission = true
        break
      }
    }

    if (!hasPermission) {
      el.style.display = 'none'
      el.remove()
    }
  }
})

// 只是属于管理员
Vue.directive('belong-to-admin', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el, binding) {
    if (localStorage.userInfo) {
      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.loginPath !== 'channel') {
        return
      }
    }
    el.style.display = 'none'
    el.remove()
  }
})

// 只是属于管理员
Vue.directive('belong-to-channel', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el, binding) {
    if (localStorage.userInfo) {
      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.roleName === '汽车网渠道') {
        return
      }
    }
    el.style.display = 'none'
    el.remove()
  }
})

// 只是属于管理员
Vue.directive('belong-to-dbt', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el, binding) {
    if (localStorage.userInfo) {
      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.roleName === '社群渠道') {
        return
      }
    }
    el.style.display = 'none'
    el.remove()
  }
})

Vue.http.interceptors.push(function (request, next) {
  let body = request.body

  if (body instanceof FormData) {
    request.headers.set('Content-Type', 'Multipart/form-data')
  } else {
    request.headers.set('X-Requested-With', 'XMLHttpRequest')
    request.headers.set('Access-Control-Allow-Credentials', 'true')
    request.headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
    request.body = Vue.url.params(body)
  }

  if (localStorage.userInfo) {
    let userInfo = JSON.parse(localStorage.userInfo)
    if (userInfo) {
      let loginAccountId = userInfo.id ? userInfo.id : userInfo.employeeId
      request.headers.set('token', userInfo.token + '')
      request.headers.set('loginAccountId', loginAccountId + '')
      request.headers.set('loginPath', userInfo.loginPath + '')
      request.headers.set('roleId', userInfo.roleId + '')
    }
  }

  next()
})

// Vue.http.interceptors.push(function(request, next) {
//
//   request.headers.set('X-Requested-With', 'XMLHttpRequest')
//
//   if(request.method == 'POST'){
//     request.body = Vue.url.params(request.body)
//     request.headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
//   }
//   if(localStorage.userInfo){
//     let userInfo = JSON.parse(localStorage.userInfo)
//     if(userInfo){
//
//       let loginAccountId=userInfo.id?userInfo.id:userInfo.employeeId
//       request.headers.set('token', userInfo.token+"")
//       request.headers.set('loginAccountId', loginAccountId+"")
//       request.headers.set('loginPath', userInfo.loginPath+"")
//       request.headers.set('roleId', userInfo.roleId+"")
//     }
//   }
//
//   next();
// });

// 注册一个全局自定义指令 v-focus
Vue.directive('delete', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el, binding, vnode) {
    let _this = this
    el.onclick = function () {
      let _this = vnode.context

      _this.$confirm('您是否要删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: binding.value.id
        }

        let listener = {
          success: function (dataInfo) {
            _this.$message({
              type: 'success',
              message: '删除成功'
            })

            _this.refreshList()
          }
        }
        BasicModel.post(_this, binding.value.action, params, listener)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
})

var router = new VueRouter({
  base: '/clueDistribution/',
  routes
})

router.beforeEach((to, from, next) => {
  if (window.parent.save) {
    if (to.name === 'targetDetail') {
      window.parent.save('目标详情')
    }
  }
  next(true)
})

new Vue({
  router,
  mixins: [ DateFilter ],
  render: h => h(App)
}).$mount('#app')
